var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sideBars"},_vm._l((_vm.options),function(menu){return _c('router-link',{key:menu.name,attrs:{"to":menu.routeLink}},[_vm._v(_vm._s(menu.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }